import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutColumnModule } from './layout-column/layout-column.module';
import { LayoutCenterModule } from './layout-center/layout-center.module';
import { FlexModule } from './flex/flex.module';
import { AutoFocusModule } from './auto-focus/auto-focus.module';
import { OnceNgIfModule } from './once-ng-if/once-ng-if.module';
import { OneTimeModule } from './one-time/one-time.module';
import { LayoutRowModule } from './layout-row/layout-row.module';
import { BannerContentModule } from './banner/banner-content.module';

@NgModule({
    imports: [
        CommonModule,
        AutoFocusModule,
        FlexModule,
        LayoutCenterModule,
        LayoutColumnModule,
        LayoutRowModule,
        OnceNgIfModule,
        OneTimeModule,
        BannerContentModule,
    ],
    exports: [
        AutoFocusModule,
        FlexModule,
        LayoutCenterModule,
        LayoutColumnModule,
        LayoutRowModule,
        OnceNgIfModule,
        OneTimeModule,
        BannerContentModule,
    ]
})
export class CaslinkCommonDirectivesModule {}
